import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import { useAppContext } from '../../context/AppContext.js';
import Brief from '../../components/Brief.js';
import { getWords } from '../../utils/get-words.js';
import { protect } from '../../utils/protect.js';

const BudgetOperationTopPart1 = ReactRouterDOM.withRouter(function ({ budgetOperation }) {
  const { i18n, setError } = useAppContext();
  const words = getWords(i18n.code);

  return (
    <div>
      <div>
        <Brief
          fieldsDisposition="spaces-between"
          fieldsSize="large"
          fields={[
            {
              label: words.operationType,
              type: 'string',
              value: budgetOperation.operationTypeName,
              secondaryField: {
                type: 'string',
                value: budgetOperation.operationTypeCode,
              },
            },
            {
              label: words.businessUnit,
              type: 'string',
              value: budgetOperation.businessUnitName,
              secondaryField: {
                type: 'string',
                value: budgetOperation.businessUnitCode,
              },
            },
            {
              label: words.segment,
              type: 'string',
              value: budgetOperation.segmentName,
              secondaryField: {
                type: 'string',
                value: budgetOperation.segmentCode,
              },
            },
            {
              label: words.branch,
              type: 'string',
              value: budgetOperation.branchName,
              secondaryField: {
                type: 'string',
                value: budgetOperation.branchCode,
              },
            },
            {
              label: words.officer,
              type: 'string',
              value: protect(function ([firstName, lastName]) { return `${firstName} ${lastName}` }, [ budgetOperation.userFirstName, budgetOperation.userLastName ]),
              secondaryField: {
                type: 'string',
                value: budgetOperation.userUsername,
              },
            },
          ]}
        />
      </div>
    </div>
  );
})

export default BudgetOperationTopPart1;
